export default {
  chapters: 'Chapters',
  bookmarks: 'Bookmarks',
  highlights: 'Highlights',
  bookInfo: 'Book info',
  author: 'Author',
  title: 'Title',
  page: 'Page',
  pages: 'pages',
  chaptersTitle: 'Content',
  bookInfoTitle: 'Information about the book',
  bookmarksTitle: 'Bookmark',
  notesTitle: 'Notes',
  fileName: 'File name',
  year: 'Year',
  format: 'Format',
  fileSize: 'File size',
  loadingBook: 'Loading book',
  textSize: 'Text size',
  textColor: 'Background color',
  appearenceTitle: 'Appearence',
  viewMode: 'Text flow',
  addNote: 'Add note',
  editNote: 'Edit note',
  addBookmark: 'Add bookmark',
  deleteHighlight: 'Delete highlight',
  default: 'Default',
  of: 'of',
  onePage: 'One page',
  twoPages: 'Two pages',
  scrolling: 'Scrolling',
  zoom: 'Zoom',
  found: 'Found',
  searchResults: 'search results',
  searchResult: 'search results',
  searchResultsThanFive: 'search results',
  notFound: 'Not found',
  errorInfo: 'An error occurred.',
  closeReaderBtn: 'Back to the library',
  genres: 'Genres',

  isbn: 'ISBN',
  annotation: 'Annotation',
  authors: 'Authors',
  publisher: 'Publisher',
  series: 'Series',
  filter: 'Filter',
  export: 'Export Notes'
}



// WEBPACK FOOTER //
// ./src/locale/en-US/reader.js